<template>
  <div class="confirm-password">
    <div class="background">
      <div style="padding: 10px 20px">
        <button class="btn-back" @click="backToLogin">
          <b-icon icon="arrow-left"></b-icon> Voltar
        </button>
      </div>
      <div>
        <b-container>
          <b-row>
            <b-card>
              <b-alert v-model="showError" show variant="danger" dismissible>
                <b-icon icon="x-circle-fill" variant="danger"></b-icon>
                {{ textError }}
              </b-alert>
              <b-alert
                v-model="showConfirmation"
                show
                variant="success"
                dismissible
              >
                <b-icon icon="check-circle" variant="success"></b-icon>
                {{ textConfirmation }}
              </b-alert>
              <div>
                <b-form @submit="submit">
                  <h2 class="pb-3">Recuperar senha</h2>
                  <b-form-group label="Digite sua nova senha:">
                    <b-form-input
                      type="password"
                      required
                      v-model="form.password"
                      class="form-control"
                      placeholder
                      :state="validateState('password')"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group class="pb-3" label="Digite novamente a senha:">
                    <b-form-input
                      type="password"
                      required
                      v-model="newPasswordVerify"
                      class="form-control"
                      placeholder
                      :state="validateState('newPasswordVerify')"
                    ></b-form-input>
                  </b-form-group>

                  <div class="d-flex justify-content-center">
                    <button class="btn-submit" type="submit">
                      ENVIAR
                      <b-spinner v-show="showSpinner" small></b-spinner>
                    </button>
                  </div>
                </b-form>
              </div>
            </b-card>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required, sameAs } from 'vuelidate/lib/validators';
import { ResetPassword } from '../services/Auth';

export default {
  mixins: [validationMixin],
  data() {
    return {
      showError: false,
      textError: 'Erro inesperado! Tente novamente.',
      showConfirmation: false,
      textConfirmation: 'Senha recuperada com sucesso!',
      showSpinner: false,
      newPasswordVerify: '',
      form: {
        password: '',
      },
    };
  },
  validations: {
    form: {
      password: {
        required,
      },
      newPasswordVerify: {
        sameAs: sameAs('password'),
        required,
      },
    },
  },
  methods: {
    validateState(field) {
      const { $dirty, $error } = this.$v.form[field];
      return $dirty ? !$error : null;
    },
    backToLogin() {
      this.$router.push('/');
    },
    submit(evt) {
      evt.preventDefault();
      this.showSpinner = true;
      const { token } = this.$route.params;

      ResetPassword(token, this.form)
        .then(() => {
          this.showConfirmation = true;
          this.showSpinner = false;
        })
        .catch(() => {
          this.showError = true;
          this.showSpinner = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
h2 {
  font-size: 1.5rem;
  margin-bottom: 12px;
}

.confirm-password {
  background-color: #e5e5e5;
  height: 100vh;
  width: 100vw;
  overflow: auto;
  color: white;
}

.btn-back {
  background-color: transparent;
  border: none;
  color: #5e5a5a;
  font-size: 20px;
  padding: 12px;
}

.btn-back:focus {
  outline: none;
  border: none;
}

.card {
  border: 0px;
  background-color: #be8250;
  box-shadow: 1px 4px 6px 2px #666666;
  border-radius: 25px;
  margin: 0 auto;
  margin-bottom: 20px;
  margin-top: 100px;
  width: 24rem;
}

.form-control {
  border-radius: 12px;
  border: none;
  background-color: #eeeeee;
  margin-bottom: 12px;
}

.form-control:focus {
  box-shadow: 0 0 8px 2px #666666;
}

.btn-submit {
  color: #d0723e;
  font-size: 15px;
  background-color: #eeeeee;
  border: 1px solid #d65600;
  border-radius: 12px;
  width: 60%;
  padding: 2px 0;
}

.btn-submit:hover {
  background: #d6d5d5;
  cursor: pointer;
}

.btn-submit:focus {
  outline: none;
  border: none;
}
</style>
